const Ios = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="51"
      viewBox="0 0 80 51"
      fill="none"
    >
      <g clipPath="url(#clip0_1137_2534)">
        <path
          d="M2.79588 4.14556C2.79588 5.02583 2.25987 5.67702 1.34035 5.67702C0.574618 5.67702 0 5.02583 0 4.14556C0 3.30261 0.612583 2.61346 1.41692 2.61346C2.25987 2.61346 2.79588 3.30261 2.79588 4.14556ZM0.676287 50.1762V14.9655H2.11959V50.1762H0.676287ZM50.125 25.0886C50.125 42.8406 40.2703 50.9104 29.4831 50.9104C18.4637 50.9104 9.54008 42.1817 9.54008 25.8228C9.54008 9.02563 18.7745 0.00225844 30.2592 0.00225844C41.5109 0.000971501 50.125 8.87699 50.125 25.0886ZM11.0027 25.4553C11.0027 38.9154 17.5262 49.3718 29.5513 49.3718C41.6602 49.3718 48.6051 38.5937 48.6051 25.3022C48.6051 12.9765 43.0404 1.72804 30.3422 1.72804C17.6439 1.72804 11.0027 12.3189 11.0027 25.4553ZM55.422 46.361C57.8434 47.9748 62.0228 49.5333 65.6172 49.5333C72.4392 49.5333 78.5065 44.7607 78.5065 37.736C78.5065 31.217 74.4649 27.8156 67.6029 24.8936C61.4616 22.2785 55.94 19.4402 55.94 12.4714C55.94 5.20986 61.6611 0.0736836 69.4368 0.0736836C73.6181 0.0736836 76.7724 1.24737 78.2395 2.27435L77.6565 3.5407C76.4094 2.66107 73.0389 1.54015 69.3725 1.54015C61.1547 1.54015 57.5751 7.74963 57.5751 12.3208C57.5751 18.6346 62.4693 20.7458 68.7779 23.7534C76.1128 27.3471 80 30.5162 80 37.4123C80 44.8212 74.719 50.8351 65.3295 50.8351C61.4411 50.8351 56.967 49.5153 54.7663 47.8275L55.422 46.361Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1137_2534">
          <rect width="80" height="50.912" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Ios;
